<rask-header [uppercase]="true">
    Generellt
</rask-header>
<rask-container-block>
    <ng-container header>
        Commandtest
    </ng-container>
    <rask-selector class="col-3"
        aid="command-picker"
        label="Command-picker"
        [(ngModel)]="currentCommand"
        [minCharacters]="3"
        [debounceTime]="300"
        (change)="commandSelected($event)"
        [viewFormatter]="commandViewFormatter"
        [formatter]="commandFormatter"
        placeholder="Ange minst tre tecken"
        [search]="commandTypeAhead">
    </rask-selector>
    <br />
    <rask-textarea class="col-6" [rows]="10" label="Command" [(ngModel)]="message"></rask-textarea>
    <br />
    <rask-input class="col-6" label="ByteConvertField" [(ngModel)]="byteConvertField"></rask-input>
    <ng-container footer>
        <rask-button color="secondary" (click)="sendCommand()">
            <span translate>Skicka till API</span>
        </rask-button>
        <rask-button color="secondary" (click)="sendCommandService()">
            <span translate>Skicka till service</span>
        </rask-button>
    </ng-container>
</rask-container-block>

<rask-container-block>
    <ng-container header>
        Ny Naturvärdesbedömning - Rensa gamla formatet på ej färdigställda NVB
    </ng-container>
    <div class="row">
        <div class="col-6">
            <rask-toggle-panel label="Visa vilka EJ LEVERANSVIRKE-kontrakt NVB som kommer att rensas"
                [defaultExpanded]="false">
                <ng-container>
                    <rask-button color="secondary" (click)="getRensaEjLevvKontraktNvb()">
                        <span translate>Visa EJ Leveransvirke</span>
                    </rask-button>
                    @if (leveransvirkeKontraktToRensa) {
                    <h2>Antal rader: {{leveransvirkeKontraktToRensa.length}}</h2>
                    }
                    @if (leveransvirkeKontraktToRensa && leveransvirkeKontraktToRensa.length > 0) {
                    <rask-list [data]="leveransvirkeKontraktToRensa">
                        <rask-list-column header="KontraktId" [sortable]="true" field="kontraktId"></rask-list-column>
                        <rask-list-column header="Kontraktnummer" [sortable]="true"
                            field="kontraktnummer"></rask-list-column>
                        <rask-list-column header="Namn" [sortable]="true" field="namn"></rask-list-column>
                        <rask-list-column header="Ansvarig virkesköpare" [sortable]="true"
                            field="ansvarigVirkeskopare"></rask-list-column>
                    </rask-list>
                    }
                </ng-container>
            </rask-toggle-panel>
        </div>
        <div class="col-6">
            <rask-toggle-panel label="Visa vilka LEVERANSVIRKE-kontrakt NVB som kommer att rensas"
                [defaultExpanded]="false">
                <ng-container>
                    <rask-button color="secondary" (click)="getRensaLevvKontraktNvb()">
                        <span translate>Visa Leversansvirke</span>
                    </rask-button>
                    @if (ejLeveransvirkeKontraktToRensa) {
                    <h2>Antal rader: {{ejLeveransvirkeKontraktToRensa.length}}</h2>
                    }
                    @if (ejLeveransvirkeKontraktToRensa && ejLeveransvirkeKontraktToRensa.length > 0) {
                    <rask-list [data]="ejLeveransvirkeKontraktToRensa">
                        <rask-list-column header="KontraktId" [sortable]="true" field="kontraktId"></rask-list-column>
                        <rask-list-column header="Kontraktnummer" [sortable]="true"
                            field="kontraktnummer"></rask-list-column>
                        <rask-list-column header="Namn" [sortable]="true" field="namn"></rask-list-column>
                        <rask-list-column header="Ansvarig virkesköpare" [sortable]="true"
                            field="ansvarigVirkeskopare"></rask-list-column>
                    </rask-list>
                    }
                </ng-container>
            </rask-toggle-panel>
        </div>

        <div class="col-12">
            <rask-toggle-panel label="RENSA GAMLA NVB" [defaultExpanded]="false">
                <ng-container>
                    <rask-button color="primary" negative (click)="rensaKontraktNVB()">Rensa</rask-button>
                </ng-container>
            </rask-toggle-panel>
        </div>
    </div>

    <ng-container footer>
    </ng-container>
</rask-container-block>